import styles from './AnalyticsChart.module.css';

interface ChartEntry {
    label: string;
    count: number;
    color?: string;
}

interface AnalyticsChartProps {
    entries: ChartEntry[];
    type?: 'bar' | 'horizontal-bar';
    total?: number;
}

const DEFAULT_COLORS = [
    'var(--option-color-1)',
    'var(--option-color-2)',
    'var(--option-color-3)',
    'var(--option-color-4)',
    'var(--option-color-5)',
    'var(--option-color-6)',
];

export function AnalyticsChart({ entries, type = 'horizontal-bar', total }: AnalyticsChartProps) {
    const totalCount = total ?? entries.reduce((acc, e) => acc + e.count, 0);

    if (entries.length === 0) {
        return <p className={styles.empty}>Sin datos</p>;
    }

    if (type === 'bar') {
        const maxCount = Math.max(...entries.map((e) => e.count));
        return (
            <div className={styles.barChart}>
                {entries.map((entry, i) => {
                    const heightPct = maxCount > 0 ? (entry.count / maxCount) * 100 : 0;
                    const color = entry.color ?? DEFAULT_COLORS[i % DEFAULT_COLORS.length];
                    const pct = totalCount > 0 ? Math.round((entry.count / totalCount) * 100) : 0;
                    return (
                        <div key={entry.label} className={styles.barColumn}>
                            <span className={styles.barValue}>{entry.count}</span>
                            <div className={styles.barTrack}>
                                <div
                                    className={styles.barFill}
                                    style={{ height: `${heightPct}%`, backgroundColor: color }}
                                />
                            </div>
                            <span className={styles.barLabel}>{entry.label}</span>
                            <span className={styles.barPct}>{pct}%</span>
                        </div>
                    );
                })}
            </div>
        );
    }

    // horizontal-bar (default)
    return (
        <div className={styles.hBarChart}>
            {entries.map((entry, i) => {
                const pct = totalCount > 0 ? Math.round((entry.count / totalCount) * 100) : 0;
                const color = entry.color ?? DEFAULT_COLORS[i % DEFAULT_COLORS.length];
                return (
                    <div key={entry.label} className={styles.hBarRow}>
                        <span className={styles.hBarLabel}>{entry.label}</span>
                        <div className={styles.hBarTrack}>
                            <div
                                className={styles.hBarFill}
                                style={{ width: `${pct}%`, backgroundColor: color }}
                            />
                        </div>
                        <span className={styles.hBarStats}>
                            {entry.count} <span className={styles.hBarPct}>({pct}%)</span>
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
